export default "__VITE_ASSET__3BD6LsSC__ 960w, __VITE_ASSET__DCb5KHST__ 1440w";